import type { InvestigationCollectionItem, LocationCollectionItem } from '@nuxt/content'

export default async function (article?: InvestigationCollectionItem) {
  const key = article ? article.id : 'all'

  return useAsyncData<LocationCollectionItem[], Error>(key, async () => {
    const query = queryCollection('location')

    if (article)
      query.where('path', 'LIKE', `%${article.path}%`)

    return query.all()
  }, {
    default() {
      return <LocationCollectionItem[]>[]
    },
  })
}
